import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {Col,Container, Row} from "reactstrap";
import {IWindow} from "../../index";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const IWindow: IWindow = (window as IWindow);

export class RoleFormData {
    @observable party_id = IWindow.initialState.user.party_id || null;
    @observable name = '';
    @observable description = '';
    @observable default_role = '';
    @observable is_active = true;
}

export class RoleForm extends CrudForm {
    modelName = 'Role';
    renderFields() {
        return (
            <>
            
                <Field
                    label="Title"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Description"
                    name="description"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />
            </>
        );
    }
}

export class RoleFilterForm {
}

export class RoleList extends CrudList {
    modelName = 'Role';

    colums() {
        return [
            {
                name: "name",
                label: "Role Title",
            },
            {
                name: "description",
                label: "Role Description",
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (

            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
                </Row>
            <Row className="form-row">
                <Col md={3} lg={5} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
           
        );  
    }
}

export class RolePage extends CrudPage {
    modelName = 'Role';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/RolePage.tsx